import {default as axios} from "axios";
import { withSocialChannelHeaders } from "../social-auth/social-channel";
import { useIsSocialMode } from "../social-auth/social-mode-context";
import {useBaseApi} from "../useBaseApi";

export function useProfileRepository() {
    const isSocialMode = useIsSocialMode();
    const {put, get} = useBaseApi();

    const createProfile = async (body) => {
        return await axios.post(process.env.API + "/company", body, {
            headers: withSocialChannelHeaders({"Content-Type": "application/json"}, isSocialMode),
        });
    }

    const updateProfile = async (body) => {
        return await put("/company", body);
    }

    const loadCurrentProfile = async () => {
        let response = await get("/company/current");
        return response.data;
    }

    return {
        createProfile,
        updateProfile,
        loadCurrentProfile
    };
}